// Mock data para Miembros Premier

export const mockStores = [
  {
    id: '1',
    name: 'Nike',
    category: 'Deportivo',
    benefit: 'Hasta 30% adicional hoy',
    isParticipating: true,
    logo: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop',
    description: 'Aprovecha tu membresía Premier y obtén un descuento adicional en toda la tienda.',
    validUntil: '2025-08-31',
    conditions: ['Aplica en productos seleccionados', 'No acumulable con otras promociones', 'Válido de lunes a domingo'],
    mapPosition: { x: '35%', y: '40%' },
    isFeatured: true
  },
  {
    id: '2',
    name: 'Zara',
    category: 'Moda',
    benefit: '20% extra en nueva colección',
    isParticipating: true,
    logo: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=200&h=200&fit=crop',
    description: 'Descuento exclusivo en la nueva colección de temporada.',
    validUntil: '2025-08-15',
    conditions: ['Solo en tienda física', 'Presentar QR al momento del pago'],
    mapPosition: { x: '55%', y: '35%' },
    isFeatured: true
  },
  {
    id: '3',
    name: 'Apple Store',
    category: 'Tecnología',
    benefit: '15% en accesorios',
    isParticipating: true,
    logo: 'https://images.unsplash.com/photo-1611472173362-3f53dbd65d80?w=200&h=200&fit=crop',
    description: 'Descuento especial en todos los accesorios Apple.',
    validUntil: '2025-09-30',
    conditions: ['No aplica en iPhones ni iPads', 'Válido en compras mayores a $500'],
    mapPosition: { x: '45%', y: '55%' },
    isFeatured: true
  },
  {
    id: '4',
    name: 'Sephora',
    category: 'Belleza',
    benefit: '25% en productos seleccionados',
    isParticipating: true,
    logo: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=200&h=200&fit=crop',
    description: 'Descuento especial en maquillaje y cuidado de la piel.',
    validUntil: '2025-07-31',
    conditions: ['Solo este mes', 'Aplica en marcas participantes'],
    mapPosition: { x: '25%', y: '60%' },
    isFeatured: true
  },
  {
    id: '5',
    name: 'Starbucks',
    category: 'Alimentos',
    benefit: 'Bebida grande gratis',
    isParticipating: true,
    logo: 'https://images.unsplash.com/photo-1545665225-b23b99e4d45e?w=200&h=200&fit=crop',
    description: 'Una bebida grande gratis en tu primera compra del mes.',
    validUntil: '2025-12-31',
    conditions: ['Una por mes', 'En compras mayores a $100'],
    mapPosition: { x: '65%', y: '50%' },
    isFeatured: true
  },
  {
    id: '6',
    name: 'H&M',
    category: 'Moda',
    benefit: '10% adicional',
    isParticipating: false,
    logo: 'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=200&h=200&fit=crop',
    description: 'Próximamente disponible',
    validUntil: '',
    conditions: [],
    mapPosition: { x: '40%', y: '25%' },
    isFeatured: false
  },
  {
    id: '7',
    name: 'Cinépolis',
    category: 'Entretenimiento',
    benefit: '2x1 en boletos',
    isParticipating: false,
    logo: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=200&h=200&fit=crop',
    description: 'Próximamente disponible',
    validUntil: '',
    conditions: [],
    mapPosition: { x: '70%', y: '65%' },
    isFeatured: false
  }
];

export const mockBenefits = [
  {
    id: 'b1',
    storeId: '1',
    storeName: 'Nike',
    title: 'Solo este fin',
    description: 'Hasta 30% adicional hoy',
    isNew: true,
    isActivated: false,
    validUntil: '2025-08-31'
  },
  {
    id: 'b2',
    storeId: '2',
    storeName: 'Zara',
    title: '20% extra',
    description: '20% extra en nueva colección',
    isNew: true,
    isActivated: false,
    validUntil: '2025-08-15'
  },
  {
    id: 'b3',
    storeId: '3',
    storeName: 'Apple Store',
    title: '15% en accesorios',
    description: '15% en accesorios',
    isNew: false,
    isActivated: true,
    validUntil: '2025-09-30'
  }
];

export const mockNotifications = [
  {
    id: 'n1',
    title: 'Nuevo beneficio disponible 🎁',
    message: 'Nike tiene un nuevo descuento esperándote',
    isRead: false,
    date: '2025-07-10'
  },
  {
    id: 'n2',
    title: 'Tu QR ha sido usado',
    message: 'Tu QR fue escaneado en Zara hace 2 horas',
    isRead: true,
    date: '2025-07-09'
  },
  {
    id: 'n3',
    title: 'Último día para este beneficio',
    message: 'El beneficio de Sephora vence mañana',
    isRead: false,
    date: '2025-07-08'
  }
];

export const mockUser = {
  name: 'María',
  email: 'maria@example.com',
  phone: '+52 55 1234 5678',
  memberSince: '2025-01-15',
  isActive: true
};

export const membershipPlan = {
  name: 'Acceso Miembros Premier',
  price: 277,
  currency: 'MXN',
  period: 'mes',
  benefits: [
    'Acceso a muchísimas de tus marcas favoritas',
    'Beneficios exclusivos semanales',
    'QR dinámico antifraude',
    'Notificaciones de ofertas especiales',
    'Cancela en el momento que quieras'
  ]
};
